import {
  Anchor,
  Button,
  Checkbox,
  Container,
  Group,
  Modal,
  Paper,
  PasswordInput,
  Text,
  TextInput,
  Title,
} from '@mantine/core';
import { useForm } from '@mantine/form';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { validateEmail } from '../utils/validateEmail';
import { validatePassword } from '../utils/validatePassword';
import { useLazyRegisterQuery } from '../endpoints/user';
import ReCaptcha from 'react-google-recaptcha';

const Registration = () => {
  let navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [registerUser] = useLazyRegisterQuery();
  const [response, setResponse] = useState('');
  const [errorResponse, setErrorResponse] = useState('');

  const handleCaptchaChange = (value) => {
    setResponse(value);
  };

  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      email: '',
      password: '',
    },
    validate: {
      email: validateEmail,
      password: validatePassword,
    },
  });

  const returnToLogin = () => {
    navigate('/login');
  };

  const handleRegister = async () => {
    // send emails here
    try {
      await registerUser({
        username: form.getInputProps('email').value,
        password: form.getInputProps('password').value,
        response: response,
      }).unwrap();
      setShowModal(true);
    } catch (error) {
      const data = error.data.error.startsWith(
        'duplicate key value violates unique constraint'
      )
        ? `The email ${form.getInputProps('email').value} has been taken.`
        : `${error.data.error}.`;
      setErrorResponse(data);
    }
  };

  const handleModalClose = () => {
    navigate('/login');
    setShowModal(false);
  };

  return (
    <Container size={420} my={40}>
      <Title align="center">Join Consili</Title>

      <Paper withBorder shadow="md" p={30} mt={30} radius="md">
        <form onSubmit={form.onSubmit(handleRegister)}>
          <TextInput
            label="Email"
            placeholder="you@consili.dev"
            required
            {...form.getInputProps('email')}
          />
          <PasswordInput
            label="Password"
            placeholder="Your password"
            required
            mt="md"
            mb="md"
            {...form.getInputProps('password')}
          />

          <ReCaptcha
            sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
            onChange={handleCaptchaChange}
          />

          <Button fullWidth mt="md" type="submit">
            Register
          </Button>
          {errorResponse && (
            <Text size="sm" c="red" mt="sm" fw={600}>
              {errorResponse}
            </Text>
          )}
          <Checkbox mt="sm" label="Remember me" />

          <Group position="apart" mt="sm" justify="space-between">
            <Anchor component="button" size="sm">
              Forgot password?
            </Anchor>
            <Anchor component="button" size="sm" onClick={returnToLogin}>
              Return to Login
            </Anchor>
          </Group>
        </form>
      </Paper>

      <Modal.Root
        opened={showModal}
        onClose={handleModalClose}
        centered
        size="md"
      >
        <Modal.Overlay />
        <Modal.Content>
          <Modal.Header>
            <Modal.Title c="red" fw={600}>
              Registrations are currently closed.
            </Modal.Title>
            <Modal.CloseButton />
          </Modal.Header>
          <Modal.Body>
            <Text size="md">
              We are not accepting open sign-ups at this time.
            </Text>
            <Text size="md" mt="md">
              To keep you updated, we have added{' '}
              {form.getInputProps('email').value} to a waitlist and will notify
              you when registrations open.
            </Text>{' '}
          </Modal.Body>{' '}
        </Modal.Content>
      </Modal.Root>
    </Container>
  );
};

export default Registration;
